import React from 'react';
import { useSelector } from 'react-redux';

// Components
import SubmittingButton from 'components/SubmittingButton';

// Types
import { AppState } from 'services/types';

// Local Selectors
import { makeSelectWarningDisabled } from './selectors';

interface Props {
    disabled?: boolean;
    label?: string;
}

const NAMESPACE = ['EVENT_CREATE', 'EVENT_UPDATE'];

export default function GeneralEventSubmitButton(
    props: Props
): React.ReactElement {
    const { disabled, label } = props;
    const warningDisabled = useSelector((state: AppState) =>
        makeSelectWarningDisabled()(state, props)
    );

    return (
        <SubmittingButton
            type="submit"
            namespace={NAMESPACE}
            primary
            disabled={disabled || warningDisabled}
        >
            {label}
        </SubmittingButton>
    );
}

GeneralEventSubmitButton.defaultProps = {
    disabled: false,
    label: 'Submit'
};
